
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 66 66"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#22353B","d":"M22 44h22V22H22z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#009CC8","d":"M44 44h22V22H44zM0 44h22V22H0z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#4FC6DF","d":"M44 22h22V0H44z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#009CC8","d":"M22 22h22V0H22z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#A36CAB","d":"M0 22h22V0H0z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#405152","d":"M0 66h22V44H0z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#0A1718","d":"M22 66h22V44H22z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#E05B25","d":"M44 66h22V44H44z"}}),_c('path',{attrs:{"fill":"#FFF","stroke":"#FFF","d":"M43.5 22.5v21h-2.1V26.2l-7.9 14.1h-1l-7.9-14v17.2h-2.1v-21h1.8L33 37.6l8.7-15.1z"}}),_c('path',{attrs:{"fill":"none","stroke":"#FFF","stroke-width":"3","d":"M9 9h48v48H9z"}})])
          )
        }
      }
    